<template>
  <div class="member-aside">
    <div class="logo-view">
      <a :href="homeHostName" class="logo"><img src="../../assets/img/logo.png" alt=""></a>
    </div>
    <dl class="nav-item-home">
      <dt>
        <router-link :to="{name: 'memberIndex'}">Main</router-link>
      </dt>
    </dl>
    <dl v-for="nav in navList" :class="`nav-item-${nav.name}`">
      <dt>{{nav.title}}</dt>
      <dd v-for="children in nav.children">
        <router-link :to="children.link">{{children.title}}</router-link>
      </dd>
    </dl>
     <dl class="nav-item-economicCalendar">
      <dt>
        <router-link :to="{name: 'EconomicCalendar'}">Economic Calendar</router-link>
      </dt>
    </dl>
  </div>
</template>

<script>
export default {
  data() {
    return {
      homeHostName: 'http://www.zfx.co.uk'
    }
  },
  computed: {
    navList() {
      const nav = [
        {
          name: 'funds',
          title: 'Funds',
          children: [
            {
              link: { name: 'deposit' },
              title: 'Deposit'
            },
            {
              link: { name: 'Withdraw' },
              title: 'Withdrawal'
            },
            {
              link: { name: 'transfer' },
              title: 'Transfer'
            },
            {
              link: { name: 'DepositRecord' },
              title: 'Deposit Record'
            },
            {
              link: { name: 'WithdrawRecord' },
              title: 'Withdrawal Record'
            },
            {
              link: { name: 'TransferRecord' },
              title: 'Transfer Record'
            }
          ]
        },
        {
          name: 'mt4',
          title: 'MT4',
          children: [
            {
              link: { name: 'LiveMT4' },
              title: 'Live  MT4'
            },
            {
              link: { name: 'DemoMt4' },
              title: 'Demo MT4'
            }
          ]
        },
        {
          name: 'account',
          title: 'Account',
          children: [
            {
              link: { name: 'AccountAuth' },
              title: 'Personal Details'
            },
            {
              link: { name: 'securitySettings' },
              title: 'Security Settings'
            }
            /*  {
              link: { name: 'EconomicCalendar' },
              title: 'Economic Calendar'
            } */
          ]
        }
      ]
      return nav
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.member-aside {
  position: absolute;
  width: 224px;
  height: 100%;
  background-color: #333333;
  .logo-view {
    height: 90px;
    background: #fff;
    .logo {
      display: block;
      padding: 20px 0 0 34px;
    }
  }
  dl {
    line-height: 50px;
    border-bottom: 1px solid #1b1b1b;
    background: url('../../assets/img/arrow.png') 180px 25px no-repeat;
  }
  dt {
    line-height: 57px;
    padding-left: 52px;
    background: 18px center no-repeat;
    color: #0A95FF;
  }
  dd {
    a {
      display: block;
      padding-left: 52px;
      color: #999999;
    }
    .router-link-active {
      background: #0A95FF;
      color: #fff;
    }
  }
  .nav-item-home {
    border-top: none;
    background-image: none;
  }
  .nav-item-economicCalendar {
    border-top: none;
    background-image: none;
  }
  .nav-item-agent {
    border-bottom: none;
  }
  @each $item in home account mt4 funds economicCalendar {
    .nav-item-#{$item} dt {
      background-image: url('../../assets/img/#{$item}.png');
    }
  }
}
</style>
